exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/design-system.js-WebpackMultiOutput";